import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import {
  getAnalytics,
  isSupported as isAnalyticsSupported
} from 'firebase/analytics';

// Single Firebase project (crystal-ui) used for the whole web app:
// push notifications (FCM) and analytics.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

export const firebaseApp = initializeApp(firebaseConfig);

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(firebaseApp);
    }
    console.log('Firebase is not supported in this browser');
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();

export const analytics = (async () => {
  try {
    const isSupportedBrowser = await isAnalyticsSupported();
    if (isSupportedBrowser) {
      return getAnalytics(firebaseApp);
    }
    console.log('Firebase Analytics is not supported in this browser');
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();
